import HospitalCounters from './HospitalCounters';

export default HospitalCounters;
